import { FC } from 'react';
import { Badge } from '@/components/ui/badge';

interface StatusBadgeProps {
  active: boolean;
  archived?: boolean;
}

export const StatusBadge: FC<StatusBadgeProps> = ({ active, archived }) => {
  if (archived) {
    return (
      <Badge
        className="bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200"
        variant="outline"
      >
        Archived
      </Badge>
    );
  }
  if (active) {
    return (
      <Badge
        className="bg-green-50 text-green-700 hover:bg-green-100 border-green-200"
        variant="outline"
      >
        Active
      </Badge>
    );
  }

  return (
    <Badge className="bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200" variant="outline">
      Inactive
    </Badge>
  );
};
